<template>
	<div class="merchant_selector">
		<div class="select_box">
			<div class="d_flex align_items_center">
				<a @click="modalMerchant = true" class="name">{{
					$store.state.auth.merchantInfo.merchant_name
				}}</a>
				<span class="icon"></span>
			</div>
			<p class="text_1">
				{{ $store.state.auth.merchantInfo.merchant_id }}
			</p>
		</div>
	</div>

	<ModalViewM
		v-if="modalMerchant"
		add-class="merchant"
		@closeModal="modalMerchant = false"
	>
		<template #title>
			<h3 class="modal_title_m mb_16">
				{{ merchantModalTitle }}
			</h3>
		</template>
		<MerchantPickerM
			@changeMode="changeMerchantMode"
			@selectMerchant="selectMerchant"
		></MerchantPickerM>
	</ModalViewM>
</template>

<script>
import { mapGetters } from 'vuex';
import ModalViewM from '@/components/Layout/ModalView.m';
import MerchantPickerM from '@/components/Merchant/MerchantPicker.m';
export default {
	name: 'SelectorComponent',
	components: {
		ModalViewM,
		MerchantPickerM,
	},
	data() {
		return {
			modalMerchant: false,
			merchantModalMode: '',
		};
	},
	// created() {
	// 	this.selectMerchant(this.$route);
	// },
	computed: {
		...mapGetters('auth', ['is_logged_in']),
		...mapGetters('assets', ['assets']),
		...mapGetters('account', ['accounts']),
		merchantModalTitle() {
			return this.merchantModalMode === 'select'
				? this.$t('merchant.picker.title1')
				: this.$t('merchant.picker.title2');
		},
	},
	methods: {
		selectMerchant(obj) {
			this.toRoute(obj);
			this.$store.dispatch('auth/getMerchantInfo', obj.params.merchant_seq);
			this.modalMerchant = false;
		},
		toRoute(obj) {
			this.$router.push(obj);
		},
		changeMerchantMode(value) {
			this.merchantModalMode = value;
		},
	},
};
</script>

<style scoped></style>
